<template>
  <div>
    <div class="term-section">
      <div
        class="term-type brand_inverse_light pointer font-weight-bold text-capitalize"
        @click="toggleTermSelection"
      >
        <div class="left">
          {{ term_data.term }}
        </div>
        <div class="right" style="padding-top: 2px">
          <div class="icon icon-caret-down font-11 font-weight-400"></div>
        </div>
      </div>

      <template :ref="'list' + grand_index" v-if="current_term_data">
        <div
          class="topic-list active inactive"
          ref="topicList"
          v-for="(topic, index) in term_data.topics"
          :key="index"
          @click="setActive($event, index)"
        >
          {{ topic.id }}. {{ topic.title }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TermSection",

  props: {
    term_data: Object,
    grand_index: Number,
    current_term: {
      type: Boolean,
      default: false,
    },
    current_week: Number,
  },

  computed: {
    ...mapGetters(["getAuthUser"]),

    isCurrentTerm() {
      return this.getAuthUser.term.toLowerCase() ==
        this.term_data.term.split(" ")[0]
        ? true
        : false;
    },
  },

  data() {
    return {
      current_term_data: this.current_term,
    };
  },

  mounted() {
    this.autoSelectWeek();
  },

  methods: {
    autoSelectWeek() {
      if (this.isCurrentTerm) {
        setTimeout(() => {
          // this.$refs.topicList[this.current_week - 1].classList.remove(
          //   "inactive"
          if (this.current_week >= this.$refs.topicList.length)
            this.$refs.topicList[0].classList.remove("inactive");
          else
            this.$refs.topicList[this.current_week].classList.remove(
              "inactive"
            );
        }, 2000);
      }
    },

    toggleTermSelection() {
      this.current_term_data = !this.current_term_data;
      this.autoSelectWeek();
    },

    setActive($event, index) {
      let topics = document.querySelectorAll(".topic-list");
      topics.forEach((elm) => elm.classList.add("inactive"));

      $event.target.classList.remove("inactive");
      this.$emit(
        "selectTopic",
        this.term_data.topics[index],
        this.grand_index,
        index
      );
    },
  },
};
</script>

<style lang="scss">
.term-section {
  margin-bottom: 25px;

  .term-type {
    @include flex_row_between_nowrap;
    margin-left: 15px;
    font-size: 14px;
    line-height: 19px;
    margin-bottom: 14px;

    @include breakpoint_max(sm) {
      font-size: 13px;
      line-height: 18px;
    }

    @include breakpoint_max(xs) {
      font-size: 12px;
      line-height: 17.5px;
      font-weight: 600 !important;

      .icon {
        font-size: 9.75px !important;
      }
    }
  }

  .topic-list {
    border-radius: 30px;
    padding: 7px 15px;
    margin-bottom: 9px;
    font-size: 12px;
    line-height: 19px;
    color: $border_grey;
    cursor: pointer;

    @include breakpoint_max(xs) {
      font-size: 11px;
      line-height: 16px;
    }
  }

  .active {
    padding: 9px 15px;
    font-weight: bold;
    background: $brand_inverse_light;
    color: $brand_primary;
  }

  .inactive {
    padding: 7px 15px !important;
    color: $border_grey !important;
    background: transparent !important;
    font-weight: normal !important;
  }
}
</style>
